// extracted by mini-css-extract-plugin
export default {"dateRange":"DateRanges_dateRange__rh5lb"};